
/* JUMPSEAT – Deutsche Preisformatierung für AOV.ai */

(() => {
  const widget = ".Avada-Bundle-Offer__Upsell .AOV-Upsell__Preview";

  const selectors = [
    ".AOV-Upsell__Card-PriceFinal",
    ".AOV-Upsell__Card-PriceCompare",
    ".aov-sr-only"
  ];

  const selector = selectors
    .map(item => `${widget} ${item}`)
    .join(", ");

  function formatPrices() {
    document.querySelectorAll(selector).forEach(element => {
      const original = element.textContent;

      const formatted = original.replace(
        /€\s*([\d,]+)\.(\d{2})\b/g,
        (_, euros, cents) =>
          `${euros.replaceAll(",", ".")},${cents}\u00a0€`
      );

      if (formatted !== original) {
        element.textContent = formatted;
      }
    });
  }

  let scheduled = false;

  const observer = new MutationObserver(() => {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;
      formatPrices();
    });
  });

  formatPrices();

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();
